class LogCache {
  constructor(maxSize = 1000, ttl = 5 * 60 * 1000) { // 5 minutes TTL
    this.cache = new Map();
    this.maxSize = maxSize;
    this.ttl = ttl;
  }

  // Generate cache key from filters and pagination
  generateKey(filters, page = 1, limit = 50) {
    const filterStr = JSON.stringify(filters);
    return `logs_${filterStr}_${page}_${limit}`;
  }

  // Set cache entry
  set(key, data) {
    // Remove oldest entries if cache is full
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value;
      this.cache.delete(firstKey);
    }

    this.cache.set(key, {
      data,
      timestamp: Date.now()
    });
  }

  // Get cache entry
  get(key) {
    const entry = this.cache.get(key);
    
    if (!entry) {
      return null;
    }

    // Check if entry has expired
    if (Date.now() - entry.timestamp > this.ttl) {
      this.cache.delete(key);
      return null;
    }

    return entry.data;
  }

  // Clear cache
  clear() {
    this.cache.clear();
  }

  // Clear expired entries
  clearExpired() {
    const now = Date.now();
    for (const [key, entry] of this.cache) {
      if (now - entry.timestamp > this.ttl) {
        this.cache.delete(key);
      }
    }
  }

  // Get cache stats
  getStats() {
    return {
      size: this.cache.size,
      maxSize: this.maxSize,
      hitRate: this.hitCount / (this.hitCount + this.missCount) || 0
    };
  }
}

// Global cache instance
const logCache = new LogCache();

// Clear expired entries every minute
setInterval(() => {
  logCache.clearExpired();
}, 60 * 1000);

export default logCache;
